import type { AuthUserType } from '@sdk/authentication/types/AuthUserType';
import gettext from '@sdk/lang/gettext';
import { SaveClientFlags } from '@sdk/authentication/types';

import ICalAnnouncementSvg from '@web/assets/svg/images/ical-announcement-modal.svg';
import FeatureAnnouncementModal from '@web/components/FeatureAnnouncementModal/FeatureAnnouncementModal';
import { useICalAnnouncement } from '@web/shifts/ICalAnnouncement/iCalAnnouncement.hooks';

type Props = {
  currentUser: AuthUserType;
  saveClientFlags: SaveClientFlags;
};

const ICalAnnouncement = ({ currentUser, saveClientFlags }: Props) => {
  const { shouldBeShown, onButtonClick, dismiss, isVisible } = useICalAnnouncement(
    currentUser,
    saveClientFlags
  );

  if (!currentUser || !shouldBeShown) {
    return null;
  }

  return (
    <FeatureAnnouncementModal
      image={<ICalAnnouncementSvg />}
      isVisible={isVisible}
      dismiss={dismiss}
      title={gettext('Psst! Sync your work schedule to any calendar applications.')}
      description={gettext(
        "Now you'll be able to sync your shifts to any calendar tools you use to overlay your work schedules on top of your existing personal calendar."
      )}
      buttonText={gettext('Try it now')}
      onButtonClick={onButtonClick}
    />
  );
};

export default ICalAnnouncement;
